import { PlanWorkout, DeckDTO } from '@/generated';
import { Style } from '@mui/icons-material';
import { CardActionsProps, Grow, Card, CardContent, Typography, Stack } from '@mui/material';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

export const WorkoutCard = (props: { planId?: string; groupId: string; decks: DeckDTO[]; workout: PlanWorkout; children?: ReactElement<CardActionsProps>; timeout: number }) => {
  const { planId, decks, workout, groupId, children } = props;
  const navigate = useNavigate();

  return (
    <Grow in={true} timeout={props.timeout}>
      <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }} className="h-100">
        <CardContent sx={{ flex: 0.9 }} onClick={() => navigate(`/plan-viewer/${planId}/${groupId}/${workout.idClient}`)}>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            {workout?.name}
          </Typography>
          <Stack sx={{ alignItems: 'center', alignContent: 'center' }} gap={1} direction={'row'}>
            <Style />
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
              {decks.find((s) => s.id === workout?.deckId)?.name}
            </Typography>
          </Stack>
          <Stack sx={{ m: 1 }} direction="row">
            <Typography sx={{ fontSize: 14, justifyContent: 'center', alignContent: 'center' }} color="text.secondary" gutterBottom>
              {workout.rounds.length} Rounds
            </Typography>
          </Stack>
          <Typography sx={{ fontSize: 14, justifyContent: 'center', alignContent: 'center' }} color="text.secondary" gutterBottom>
            {workout.description}
          </Typography>
        </CardContent>
        {children}
      </Card>
    </Grow>
  );
};
